module.exports = __webpack_public_path__ + "img/store-dark.b75a8bd7.png";